/* eslint-disable */
export const TimeCodeFrameRate = {
    F23_98: 23.98,
    F24: 24,
    F25: 25,
    F29_97: 29.97,
    F30: 30,
    F50: 50,
    F59_94: 59.94,
    F60: 60,
};

const SyncSource = {
    frame: 1,
    second: 2,
    timecode: 3,
};

export default class TimeCode {
    _framerate = 0;
    _dropFrame = false;
    _intFramerate = 0;

    _frames = 0;

    _seconds = 0;

    _hrs = 0;
    _mins = 0;
    _secs = 0;
    _frs = 0;

    _thrs = 0;
    _tmins = 0;
    _tsecs = 0;

    constructor(framerate, isDropFrame) {
        this._framerate = framerate;
        this._intFramerate = this.calcIntFramerate(this._framerate);

        if (isDropFrame) {
            this._dropFrame =
                isDropFrame === true && this.checkDropFrame(framerate) === true;
        } else {
            this._dropFrame = this.checkDropFrame(framerate);
        }
    }

    getFrames = () => {
        return this._frames;
    };

    setFrames = (frames) => {
        this._frames = frames;

        this.sync(SyncSource.frame);
    };

    getSeconds = () => {
        return this._seconds;
    };

    setSeconds = (seconds) => {
        this._seconds = seconds;

        this.sync(SyncSource.second);
    };

    sync = (syncSource) => {
        if (syncSource === SyncSource.frame) {
            this.frameToTc(true);
            this.tcToSecond();
            this.secondToTime();
        } else if (syncSource === SyncSource.second) {
            this.secondToTc();
            this.tcToFrame();
            this.secondToTime();
        }
    };

    secondToFrame = () => {
        this._frames = parseInt(this._seconds * this._intFramerate);

        // console.log(`[secondToFrame] second : ${this._seconds}, infFrame : ${this._intFramerate}, frame : ${this._frames}`);
    };

    secondToTc = () => {
        let calcSec = this._seconds;

        this._hrs = parseInt(calcSec / 3600);
        calcSec = calcSec % 3600;

        this._mins = parseInt(calcSec / 60);
        calcSec = calcSec % 60;

        this._secs = parseInt(calcSec);
        calcSec = calcSec - parseInt(calcSec);

        this._frs = parseInt(calcSec * 29.0); // temp

        // console.log(`[secondToTc] second : ${this._seconds}, tc : ${this._hrs}:${this._mins}:${this._secs};${this._frs}`);
    };

    tcToSecond = () => {
        this._seconds =
            this._hrs * 3600 +
            this._mins * 60 +
            this._secs +
            this._frs / this._intFramerate;
    };

    frameToTc = (frameOnly) => {
        let totalFrames = this._frames;

        // console.log(`[frameToTc] : totalFrames(before) : ${totalFrames}`);

        if (this._dropFrame) {
            totalFrames += this.calcDropFrames(frameOnly);
        }

        // console.log(`[frameToTc] : totalFrames(after) : ${totalFrames}`);

        if (totalFrames <= 0 || this._intFramerate <= 0) {
            this._hrs = 0;
            this._mins = 0;
            this._secs = 0;
            this._frs = 0;
            return;
        }

        // console.log(`[frameToTc] total : ${totalFrames}, frrt : ${this._intFramerate}, fr : ${totalFrames % this._intFramerate} `);

        this._frs = Math.floor(totalFrames % this._intFramerate);
        totalFrames = Math.floor(totalFrames / this._intFramerate);

        this._secs = totalFrames % 60;
        totalFrames = Math.floor(totalFrames / 60);

        this._mins = totalFrames % 60;
        totalFrames = Math.floor(totalFrames / 60);

        this._hrs = totalFrames;
    };

    tcToFrame = () => {
        // console.log(`[tcToFrame] _intFramerate : ${this._intFramerate}, tc : ${this._hrs}:${this._mins}:${this._secs};${this._frs}`);

        let totalFrames =
            (this._hrs * 3600 + this._mins * 60 + this._secs) * this._intFramerate +
            this._frs;

        // console.log(`[tcToFrame] totalFrames (before) : ${totalFrames}`);

        if (this._dropFrame) {
            totalFrames -= this.calcDropFrames(false);
        }

        // console.log(`[tcToFrame] totalFrames (after) : ${totalFrames}`);

        this._frames = totalFrames;
    };

    secondToTime = () => {
        let seconds = this._seconds;

        this._thrs = parseInt(seconds / 3600);
        seconds = seconds % 3600;

        this._tmins = parseInt(seconds / 60);
        seconds = seconds % 60;

        this._tsecs = parseInt(seconds);
    };

    calcDropFrames = (frameOnly) => {
        let dropFrames = 0;

        let localHrs = 0;
        let localMin = 0;

        if (frameOnly) {
            let totalSec = 0;

            totalSec = Math.floor(this._frames / this._framerate);
            // totalSec = this._seconds;

            localHrs = Math.floor(totalSec / 3600);
            totalSec %= 3600;

            localMin = Math.floor(totalSec / 60);
        } else {
            localHrs = this._hrs;
            localMin = this._mins;
        }

        // console.log(`[calcDropFrames] localHrs : ${localHrs}, localMin : ${localMin}, ${(localMin % 10)}, ${(localMin % 10 * 2)}`);

        if (this._framerate === 59.94) {
            dropFrames =
                localHrs * 6 * 36 + parseInt(localMin / 10) * 36 + (localMin % 10) * 4;
        } else if (this._framerate === 29.97) {
            dropFrames =
                localHrs * 6 * 18 + parseInt(localMin / 10) * 18 + (localMin % 10) * 2;
        }

        // console.log(`[calcDropFrames] dropFrames : ${dropFrames}`);

        return dropFrames;
    };

    checkDropFrame = (framerate) => {
        return framerate === 29.97 || framerate === 59.94;
    };

    calcIntFramerate = (framerate) => {
        let intFramerate = 0;

        if (framerate === 59.94) {
            intFramerate = 60;
        } else if (framerate === 29.97) {
            intFramerate = 30;
        } else if (framerate === 23.98) {
            intFramerate = 24;
        } else {
            intFramerate = parseInt(framerate);
        }

        return intFramerate;
    };

    // 시, 분, 초 String 값을 얻기 위해 추가
    getValueOfHours = (type) => {
        return this._thrs < 10 && !type ? '0' + this._thrs : this._thrs;
    };
    // 시, 분, 초 String 값을 얻기 위해 추가
    getValueOfMinutes = (type) => {
        return this._tmins < 10 && !type ? '0' + this._tmins : this._tmins;
    };
    // 시, 분, 초 String 값을 얻기 위해 추가
    getValueOfSeconds = (type) => {
        return this._tsecs < 10 && !type ? '0' + this._tsecs : this._tsecs;
    };

    getTimeCode = (type, format) => {
        let result = format || 'hh:mm:ss';

        const hh = this.getValueOfHours(type);
        const mm = this.getValueOfMinutes(type);
        const ss = this.getValueOfSeconds(type);

        result = result.replace(/hh/gi, hh);
        result = result.replace(/mm/gi, mm);
        result = result.replace(/ss/gi, ss);

        return result;
    };

    getTimeCodeWithFrame(format) {
        let result = format || 'hh:mm:ss:ff';

        const hh = this._hrs < 10 ? '0' + this._hrs : this._hrs;
        const mm = this._mins < 10 ? '0' + this._mins : this._mins;
        const ss = this._secs < 10 ? '0' + this._secs : this._secs;
        const ff = this._frs < 10 ? '0' + this._frs : this._frs;

        result = result.replace(/hh/gi, hh);
        result = result.replace(/mm/gi, mm);
        result = result.replace(/ss/gi, ss);
        result = result.replace(/ff/gi, ff);

        return result;
    }
}
